import React from "react"
import * as StyledDOM from "./styles.js"
import * as Mock from "./mockData.js"
import { Grid, ButtonGroup } from "@material-ui/core"
import digitShekele from "./shekele.png"
const renderRow = () => {
  return <Grid></Grid>
}
function StaticViewPlanogram(props) {
  const {
    defaultList = [], //Mock?.fetchData?.gondola[0]?.shelf,
    shelfType = "",
  } = props || {}
  const [getListData, setListData] = React.useState(defaultList)
  React.useEffect(() => {
    setListData(defaultList)
  }, [defaultList])
  //rowItem?.cells.length > 0

  return (
    <StyledDOM.StyledMainWrapper>
      <Grid>
        {getListData.length > 0 ? (
          getListData.map((rowItem, rowIndex) => {
            return (
              <>
                {true && (
                  <Grid
                    className="cls-svp-cell-row-wrapper-ui"
                    style={{
                      borderColor: rowIndex % 2 === 0 ? "#C0D9D5" : "#BBD6E9",
                      minHeight: 100,
                    }}
                  >
                    {rowItem?.cells.length > 0 ? (
                      <Grid className="cls-svp-cell-wrapper-ui">
                        {rowItem?.cells.map((cellItem, cellIndex) => {
                          return (
                            <Grid
                              className="cls-svp-cell-item-ui"
                              style={{
                                width: `${100 / (rowItem?.cells?.length || 2)
                                  }%`,
                                backgroundColor:
                                  rowIndex % 2 === 0 ? "#e5f1ed" : "#daecf8",
                              }}
                            >
                              <Grid className="cls-svp-cell-item-label-ui">
                                <span className="cls-svp-cell-title-item-ui">
                                  {`${cellIndex === 0
                                    ? `Row: ${rowItem?.row_no || 0} | `
                                    : ""
                                    } ${cellItem?.digitshelfId?.digitshelfId}`}
                                </span>
                              </Grid>
                              <Grid className="cls-svp-cell-product-wrapper-ui">
                                {cellItem?.digitshelfId?.Linked_Products?.map(
                                  (productItem) => {
                                    return (
                                      <Grid
                                        className="cls-svp-cell-product-item-ui"
                                        style={{
                                          borderColor:
                                            rowIndex % 2 === 0
                                              ? "#C0D9D5"
                                              : "#BBD6E9",
                                          width: `${100 /
                                            (cellItem?.digitshelfId
                                              ?.Linked_Products?.length || 2)
                                            }%`,
                                        }}
                                      >
                                        <Grid
                                          className="cls-svp-cell-product-barcode-kit-item-ui"
                                          style={{
                                            fontSize: 10,
                                            fontWeight: "bold",
                                            textAlign: "center",
                                            background:
                                              rowIndex % 2 === 0
                                                ? "#C0D9D5"
                                                : "#BBD6E9",
                                          }}
                                        >
                                          {
                                            productItem?.product_id
                                              ?.barcodeValue
                                          }
                                        </Grid>
                                        <Grid
                                          className="cls-svp-cell-product-gram-kit-item-ui"
                                          style={{
                                            fontSize: 10,
                                            fontWeight: "bold",
                                          }}
                                        >
                                          <Grid
                                            className="cls-svp-cell-rotate-label"
                                            style={{
                                              background:
                                                rowIndex % 2 === 0
                                                  ? "#C0D9D5"
                                                  : "#BBD6E9",
                                            }}
                                          >
                                            {`${productItem?.product_id?.item_weight}grams`}
                                          </Grid>
                                        </Grid>
                                        <Grid className="cls-svp-cell-product-img-wrapper-item-ui">
                                          <img
                                            alt={`${productItem?.product_id?.title}`}
                                            src={
                                              productItem?.product_id
                                                ?.item_images
                                            }
                                          />
                                        </Grid>
                                        <Grid style={{ width: "100%", textAlign: "center" }}>
                                          <Grid className="cls-svp-cell-product-title-kit-item-ui">
                                            {productItem?.product_id?.title}
                                          </Grid>
                                          {window["IS_PLANOGRAM_ENABLE_AUTO_UPDATE"] === true ? <></> : <Grid
                                            className="cls-svp-cell-product-pos-kit-item-ui"
                                            style={{
                                              fontSize: 10,
                                              fontWeight: "bold",
                                              textAlign: "center",
                                              background:
                                                rowIndex % 2 === 0
                                                  ? "#C0D9D5"
                                                  : "#BBD6E9",
                                            }}
                                          >
                                            {productItem?.product_location_in_Store?.map(
                                              (pos, index) => {
                                                let posKit = {
                                                  0: "X",
                                                  1: "Y",
                                                  2: "Z",
                                                }
                                                return (
                                                  <Grid className="cls-svp-cell-product-pos-item-ui">{`${posKit[index]}: ${pos}`}</Grid>
                                                )
                                              }
                                            )}
                                          </Grid>}
                                        </Grid>
                                      </Grid>
                                    )
                                  }
                                )}
                              </Grid>
                            </Grid>
                          )
                        })}
                      </Grid>
                    ) : (
                      <Grid className="cls-svp-cell-empty-wrapper-ui">
                        <Grid>
                          <Grid>
                            {`No Records Found, Insert ${shelfType} Shelf`}
                          </Grid>
                          <img
                            style={{
                              width: "300px",
                              height: "auto",
                              marginTop: 10,
                            }}
                            alt={"digitShekele"}
                            src={digitShekele}
                          />
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                )}
              </>
            )
          })
        ) : (
          <Grid>
            <Grid>{`No Records Found, Insert ${shelfType} Shelf`}</Grid>
          </Grid>
        )}
      </Grid>
    </StyledDOM.StyledMainWrapper>
  )
}

export { StaticViewPlanogram }
export default StaticViewPlanogram
